import { YIBF_ESLESMEME_SEBEBI } from "../constants/requestUrls";
import { getRequest } from "../request";

const yibfEslesmemeSebebiList = (yibfNo) => {
    return getRequest({url:YIBF_ESLESMEME_SEBEBI+"?yibfNo="+yibfNo});
}

export default yibfEslesmemeSebebiList;